import {} from 'zod';
/** Default value applied when a feature omits `surfacedIn`: every override-capable management UI tab. */
export const DEFAULT_SURFACED_IN = ['application', 'brand', 'account', 'module'];
/**
 * Identity factory. Its only job is to preserve the literal `propName` and
 * `validValues` types via `const` inference so callers get exact-string
 * unions without restating them.
 */
export function defineFeature(def) {
    return def;
}
